// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statement-badge{display:block;padding-top:.5em}.statement-badge__badge{display:inline-block;border-radius:9999px;padding:.5em 1em .5em .75em;background-color:var(--color-background);color:var(--color-text);font-weight:700}@media (min-width:48em){.statement-badge{display:inline-block;font-size:1.125em;padding-top:0}.statement-badge+.statement-badge{margin-left:1em}}.statement-badge__icon{margin-right:.5em}", ""]);
// Exports
module.exports = exports;
